import { InjectionToken } from '@angular/core';
import { BrandConfig } from './brand.interface';

/**
 * Injection token for brand configuration
 * Used to provide brand-specific settings throughout the application
 */
export const BRAND_CONFIG = new InjectionToken<BrandConfig>('BRAND_CONFIG');
